import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	items: [],
	item: [],
	index: '',
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getTotalCart: state => {
		let price = 0;

		if (Array.isArray(state.items) && state.items.length > 0) {
			for (let item of state.items) {
				price = price + item.price * item.qt;
			}
		}

		return price.toFixed(2);
	},
};
async function createDto(payload) {
	return {
		supplier: payload.supplier
			.map(el => {
				return el.Company;
			})
			.join(','),
		image: payload?.images?.[0] ? payload?.images?.[0] : '',
		name: payload?.trans?.name,
		model: payload?.model,
		brand: payload?.brand?.trans?.name,
		category: payload.categories
			.map(el => {
				return el.trans?.name;
			})
			.join(','),
		variant: payload?.variants?.variants
			.map(el => {
				return `${el?.name?.trans}:${el?.value?.trans}`;
			})
			.join(','),
		qt: 1,
		sku: payload.variants.sku,
		ean: payload.variants.ean,
		qtunit: payload.variants.qtunit,
		price: payload.variants.pricevat,
		_item: payload._id,
		_variant: payload.variants._id,
	};
}

const actions = {
	addFromCatalog: async (context, item) => {
		const dto = item;
		const carts = Array.from(await context.state['items']);
		if (carts.length > 0) {
			const checkItem = carts.find(el => {
				return el._item === dto._item && el._variant === dto._variant;
			});
			if (checkItem) {
				checkItem.qt = checkItem.qt + 1;
			} else {
				carts.push(dto);
			}
		} else {
			carts.push(dto);
		}
		context.commit('setItems', carts);
	},
	add: async (context, item) => {
		const dto = await createDto(item);
		const carts = Array.from(await context.state['items']);
		if (carts.length > 0) {
			const checkItem = carts.find(el => {
				return el._item === dto._item && el._variant === dto._variant;
			});
			if (checkItem) {
				checkItem.qt = checkItem.qt + 1;
			} else {
				carts.push(dto);
			}
		} else {
			carts.push(dto);
		}
		context.commit('setItems', carts);
	},
	delete: async (context, item) => {
		const dto = item;
		let carts = Array.from(await context.state['items']);
		if (carts.length > 0) {
			console.log('DTO', dto);
			console.log('CART', carts);
			carts = carts.filter(el => {
				console.log('el', el);
				return el._item !== dto._item || el._variant !== dto._variant;
			});
		}
		context.commit('setItems', carts);
	},
	confirmCarts: async (context, item) => {
		let url = 'incomings/confirmcart';
		//console.log(context.rootGetters['categories/getSortBy'])
		let carts = Array.from(await context.state['items']);
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, carts, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(res => {
				if (res.data?.notifies && Array.isArray(res.data?.notifies) && res.data?.notifies.length > 0) {
					context.commit('notify/addItems', res.data?.notifies, { root: true });
				}
				context.commit('setItems', []);
				return res.data;
			})
			.catch(err => {
				console.log('errore', err.response.status);

				return { error: err.response.status };
			});
	},
	deletecart: async (context, item) => {
		context.commit('setItems', []);
	},
	updateQt: async (context, item) => {
		const dto = item;
		const carts = Array.from(await context.state['items']);
		if (carts.length > 0) {
			const checkItem = carts.find(el => {
				return el._item === dto._item && el._variant === dto._variant;
			});
			if (checkItem) {
				checkItem.qt = Number(item.qt);
			} else {
				carts.push(dto);
			}
		} else {
			carts.push(dto);
		}
		context.commit('setItems', carts);
	},
};

const mutations = {
	setItems: async (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
